// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subscribe-banner{text-align:center;background-color:#104182;color:white;padding:1rem;margin:1.5rem}.subscribe-banner a.data{color:#fff}.subscribe-banner a.data:hover{border-color:#fff}@media print{.subscribe-banner{display:none}}\n", ""]);
// Exports
module.exports = exports;
